export default {
  address: 'Adres',
  contact: 'Kontakt',
  terms: 'Warunki użytkowania',
  privacy_policy: 'Polityka prywatności',
  impressum: 'Impressum',
  cookie_policy: 'Polityka cookies',
  cookie_settings: 'Ustawienia plików cookie',
};
